"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMenuItemsTarget = void 0;
const reporters_1 = require("../../../reporters");
const errors_1 = require("../errors");
const validateMenuItemsTarget = (value) => {
    if (!value) {
        return true;
    }
    const checkMenuItemsTarget = (items, parentIndex) => {
        var _a;
        return (_a = items === null || items === void 0 ? void 0 : items.every(({ target, link = '', label = link, menuItems }, index) => {
            if (target != null && target !== '_blank' && target !== '_self') {
                throw new errors_1.InvalidTargetError({
                    index: parentIndex === undefined ? index : parentIndex,
                    label,
                    target,
                });
            }
            return checkMenuItemsTarget(menuItems, index);
        })) !== null && _a !== void 0 ? _a : true;
    };
    try {
        return checkMenuItemsTarget(value);
    }
    catch (error) {
        reporters_1.reportError(error.message);
        return false;
    }
};
exports.validateMenuItemsTarget = validateMenuItemsTarget;
//# sourceMappingURL=validateMenuItemsTarget.js.map